module.exports = __webpack_public_path__ + "static/media/lemon.a301b4c2.jpg";